import templateUrl from 'emun.auth/bank-reference-fieldset.htm'

export class controller {
    $onInit() {
        if (!this.colSplit) this.colSplit = 4;
    }
}

export default {
    bindings: {
        bus: '<',
        colSplit: '@',
        request: '=ngModel',
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}